// extracted by mini-css-extract-plugin
export default {"dot":"Dot_dot__pLxkZ","greenDot":"Dot_greenDot__88LoS","redDot":"Dot_redDot__pzLAh"};